import { WorkflowTab } from '../../../Api/Orders/ordersApi';

export const WORKFLOW_TAB_ORDER: WorkflowTab[] = [
  'submitted',
  'quoting_in_progress',
  'reviewing_approving_quotes',
  'upstack_processing_order',
  'hand_off_to_pm'
];

export const WORKFLOW_TAB_LABELS: Record<WorkflowTab, string> = {
  submitted: 'Submitted',
  quoting_in_progress: 'Quoting In Progress',
  reviewing_approving_quotes: 'Reviewing & Approving Quotes',
  upstack_processing_order: 'UPSTACK Processing Order',
  hand_off_to_pm: 'Hand Off to Project Management'
};
